import _defineProperty from "/buddy/kaporg-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { resetComponent } from '../../style';
import { initZoomMotion } from '../../style/motion';
import getArrowStyle, { getArrowOffsetToken } from '../../style/placementArrow';
import { PresetColors, genStyleHooks, mergeToken } from '../../theme/internal';
import { getArrowToken } from '../../style/roundedArrow';

var genBaseStyle = function genBaseStyle(token) {
  var _Object$assign;

  var componentCls = token.componentCls,
      popoverColor = token.popoverColor,
      titleMinWidth = token.titleMinWidth,
      fontWeightStrong = token.fontWeightStrong,
      innerPadding = token.innerPadding,
      boxShadowSecondary = token.boxShadowSecondary,
      colorTextHeading = token.colorTextHeading,
      borderRadiusLG = token.borderRadiusLG,
      zIndexPopup = token.zIndexPopup,
      titleMarginBottom = token.titleMarginBottom,
      colorBgElevated = token.colorBgElevated,
      popoverBg = token.popoverBg,
      titleBorderBottom = token.titleBorderBottom,
      innerContentPadding = token.innerContentPadding,
      titlePadding = token.titlePadding;
  return [_defineProperty({}, componentCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    position: 'absolute',
    top: 0,
    // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
    left: {
      _skip_check_: true,
      value: 0
    },
    zIndex: zIndexPopup,
    fontWeight: 'normal',
    whiteSpace: 'normal',
    textAlign: 'start',
    cursor: 'auto',
    userSelect: 'text',
    transformOrigin: "var(--arrow-x, 50%) var(--arrow-y, 50%)",
    '--antd-arrow-background-color': colorBgElevated,
    '&-rtl': {
      direction: 'rtl'
    },
    '&-hidden': {
      display: 'none'
    }
  }, _defineProperty(_Object$assign, "".concat(componentCls, "-content"), {
    position: 'relative'
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-inner"), {
    backgroundColor: popoverBg,
    backgroundClip: 'padding-box',
    borderRadius: borderRadiusLG,
    boxShadow: boxShadowSecondary,
    padding: innerPadding
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-title"), {
    minWidth: titleMinWidth,
    marginBottom: titleMarginBottom,
    color: colorTextHeading,
    fontWeight: fontWeightStrong,
    borderBottom: titleBorderBottom,
    padding: titlePadding
  }), _defineProperty(_Object$assign, "".concat(componentCls, "-inner-content"), {
    color: popoverColor,
    padding: innerContentPadding
  }), _Object$assign))), // Arrow Style
  getArrowStyle(token, 'var(--antd-arrow-background-color)'), // Pure Render
  _defineProperty({}, "".concat(componentCls, "-pure"), _defineProperty({
    position: 'relative',
    maxWidth: 'none',
    margin: token.sizePopupArrow,
    display: 'inline-block'
  }, "".concat(componentCls, "-content"), {
    display: 'inline-block'
  }))];
};

var genColorStyle = function genColorStyle(token) {
  var componentCls = token.componentCls;
  return _defineProperty({}, componentCls, PresetColors.map(function (colorKey) {
    var _$concat$concat;

    var lightColor = token["".concat(colorKey, "6")];
    return _defineProperty({}, "&".concat(componentCls, "-").concat(colorKey), (_$concat$concat = {
      '--antd-arrow-background-color': lightColor
    }, _defineProperty(_$concat$concat, "".concat(componentCls, "-inner"), {
      backgroundColor: lightColor
    }), _defineProperty(_$concat$concat, "".concat(componentCls, "-arrow"), {
      background: 'transparent'
    }), _$concat$concat));
  }));
};

export var prepareComponentToken = function prepareComponentToken(token) {
  var lineWidth = token.lineWidth,
      controlHeight = token.controlHeight,
      fontHeight = token.fontHeight,
      padding = token.padding,
      wireframe = token.wireframe,
      zIndexPopupBase = token.zIndexPopupBase,
      borderRadiusLG = token.borderRadiusLG,
      marginXS = token.marginXS,
      lineType = token.lineType,
      colorSplit = token.colorSplit,
      paddingSM = token.paddingSM;
  var titlePaddingBlockDist = controlHeight - fontHeight;
  var popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
  var popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
  var popoverPaddingHorizontal = padding;
  return Object.assign(Object.assign(Object.assign({
    titleMinWidth: 177,
    zIndexPopup: zIndexPopupBase + 30
  }, getArrowToken(token)), getArrowOffsetToken({
    contentRadius: borderRadiusLG,
    limitVerticalRadius: true
  })), {
    // internal
    innerPadding: wireframe ? 0 : 12,
    titleMarginBottom: wireframe ? 0 : marginXS,
    titlePadding: wireframe ? "".concat(popoverTitlePaddingBlockTop, "px ").concat(popoverPaddingHorizontal, "px ").concat(popoverTitlePaddingBlockBottom, "px") : 0,
    titleBorderBottom: wireframe ? "".concat(lineWidth, "px ").concat(lineType, " ").concat(colorSplit) : 'none',
    innerContentPadding: wireframe ? "".concat(paddingSM, "px ").concat(popoverPaddingHorizontal, "px") : 0
  });
};
export default genStyleHooks('Popover', function (token) {
  var colorBgElevated = token.colorBgElevated,
      colorText = token.colorText;
  var popoverToken = mergeToken(token, {
    popoverBg: colorBgElevated,
    popoverColor: colorText
  });
  return [genBaseStyle(popoverToken), genColorStyle(popoverToken), initZoomMotion(popoverToken, 'zoom-big')];
}, prepareComponentToken, {
  resetStyle: false,
  deprecatedTokens: [['width', 'titleMinWidth'], ['minWidth', 'titleMinWidth']]
});